import template from './sidemenu-button-submenu.html';
import arrow from './arrow.svg';

class Controller {
    /* @ngInject */
    constructor($scope) {
        this.arrow = arrow;

    }

    toggle() {
        this.itemCtrl.toggle();
    }

    $onInit() {
    }
}

let sidemenuButtonSubmenuComponent = {
//    restrict: 'E',
    bindings: {
        label: '@'
    },
    replace: true,
    transclude: true,
    template: template,
    controller: Controller,
    require: {
        itemCtrl: '^sidemenuItem'
    }
};

export default sidemenuButtonSubmenuComponent;
